import { render } from "./ReportProperties.vue?vue&type=template&id=a8f18bb2"
import script from "./ReportProperties.vue?vue&type=script&lang=js"
export * from "./ReportProperties.vue?vue&type=script&lang=js"

import "./ReportProperties.vue?vue&type=style&index=0&id=a8f18bb2&lang=scss"

import exportComponent from "/app/tmp/blackhall/V3/v2026.12.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__